import { createSalesPromoFeeRecord, getSalesPromoFee, getCurrentPromoFee, setActivcePromoFee, createNoContactSalesPromoFeeRecord, updatePromoFee } from '@/api/salesPromoFeeRecord'
import Vue from 'vue'

import caclSalesCost from './caclSalesCost'

const state = {
  salesPromoFeeRecordList: [],
  currentPromoFeeList: [],
  promoFeeSum: 0,
  totalCounts: 0,
  currentTotalCounts: 0,
}

const actions = {

  async getSalesPromoFeeAction({ commit }, payload) {
    try {
      const res = await getSalesPromoFee(payload)
      commit('SET_SALES_PROMOFEE_RECORD', res.data)
      return res.data.salesPromoFeeRecordList
    } catch (error) {
      throw error
    }
  },

  async getCurrentPromoFeeAction({ commit }, payload) {
    try {
      const res = await getCurrentPromoFee(payload.id)
      commit('SET_CURRENT_PROMOFEE_RECORD', res.data)
      return res.data
    } catch (error) {
      throw error
    }
  },

  async createSalesPromoFeeRecordAction({ commit }, payload) {
    try {
      const newSalesPromoFee = await createSalesPromoFeeRecord(payload.form)
      commit('CREATE_SALES_PROMOFEE_RECORD', newSalesPromoFee.data)
    } catch (error) {
      throw error
    }
  },

  async updatePromoFeeAction({ commit }, payload) {
    try {
      const newActivcePromoFee = await updatePromoFee(payload.id, payload.data)
      commit("UPDATE_SALES_PROMOFEE_RECORD", newActivcePromoFee.data)
      return newActivcePromoFee
    } catch (error) {
      throw error.message
    }
  },

  async setActivcePromoFeeAction({ commit }, payload) {
    try {
      const newActivcePromoFee = await setActivcePromoFee(payload.id, payload.data)
      commit("SET_ACTIVE_PROMOFEE", payload)
      return newActivcePromoFee
    } catch (error) {
      throw error.message
    }
  },

  async createNoContactSalesPromoFeeRecordAction({ commit }, payload) {
    try {
      const newSalesPromoFee = await createNoContactSalesPromoFeeRecord(payload.form)
      newSalesPromoFee.data.rePrice = payload.form.fee
      newSalesPromoFee.data.reSales = payload.form.sales
      commit('CREATE_NO_CONTACT_SALES_PROMOFEE_RECORD', newSalesPromoFee.data)
      return newSalesPromoFee.data
    } catch (error) {
      throw error
    }
  }
}

const mutations = {
  SET_SALES_PROMOFEE_RECORD(state, payload) {
    for (let i = 0; i < state.currentPromoFeeList.length; i++) {
      payload.salesPromoFeeRecordList.filter(x => {
        if (state.currentPromoFeeList[i]._id === x._id) {
          x._checked = true
        }
      })
    }
    state.salesPromoFeeRecordList = payload.salesPromoFeeRecordList
    state.totalCounts = payload.totalCounts
  },

  SET_CURRENT_PROMOFEE_RECORD(state, payload) {
    state.currentPromoFeeList = payload.promoFeeList
    state.promoFeeSum = payload.promoFeeSum
    state.currentTotalCounts = payload.totalCounts
  },

  CREATE_SALES_PROMOFEE_RECORD(state, payload) {
    state.salesPromoFeeRecordList.unshift(payload)
    state.totalCounts++
  },
  CREATE_NO_CONTACT_SALES_PROMOFEE_RECORD(state, payload) {
    if (payload.reCalcSalesCost) {
      Vue.set(caclSalesCost.state.salesLatestCost, caclSalesCost.state.salesLatestCost.findIndex(x => x._id === payload.sales._id), payload.sales)
    } else {
      const index = caclSalesCost.state.salesLatestCost.findIndex(x => x._id === payload.reSales)
      const sales = caclSalesCost.state.salesLatestCost[index]
      sales.promoFee = { fee: payload.rePrice }
      sales.promoFeeSum = payload.rePrice
      Vue.set(caclSalesCost.state.salesLatestCost, index, sales)
      
    }
  },

  SET_ACTIVE_PROMOFEE(state, activePromoFee) {
    const index = caclSalesCost.state.salesLatestCost.findIndex(x => x._id === activePromoFee.id)
    const sales = caclSalesCost.state.salesLatestCost[index]
    sales.promoFeeSum = activePromoFee.data.promoFee.reduce((p, c) => {
      return p+c.fee
    }, 0)
    Vue.set(caclSalesCost.state.salesLatestCost, caclSalesCost.state.salesLatestCost.findIndex(x => x._id === activePromoFee.id), sales)
  },

  UPDATE_SALES_PROMOFEE_RECORD(state, activePromoFee) {
    Vue.set(state.salesPromoFeeRecordList, state.salesPromoFeeRecordList.findIndex(x => x._id === activePromoFee._id), activePromoFee)
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}